import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Nav from '../components/Nav'
import Footer from '../components/Footer'

import './foundation.css'
import '../styles/app.scss'
import '../styles/index.scss'
import '../styles/motion.min.css'
import './layout.scss'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <React.Fragment>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'title', content: 'The Dodgies: Cast your vote!' },
            {
              name: 'description',
              content:
                'The Dodgies is here! GetUp’s inaugural scandal competition will crown one politician the nation’s dodgiest. And we need your vote!',
            },
            { property: 'og:title', content: 'Who is the dodgiest?' },
            {
              property: 'og:description',
              content:
                'The Dodgies is here! GetUp’s inaugural scandal competition will crown one politician the nation’s dodgiest. And we need your vote!',
            },
            {
              property: 'og:image',
              content: 'https://cdn.getup.org.au/image_21448_full.png',
            },
            {
              name: 'viewport',
              content:
                'width=device-width, initial-scale=1.0, viewport-fit=cover',
            },
          ]}
        >
          <html lang="en" />
          <link rel="stylesheet" href="https://use.typekit.net/fxq2vrx.css" />
          <link
            href="https://fonts.googleapis.com/css?family=Inconsolata:400,700"
            rel="stylesheet"
          />
        </Helmet>
        <Nav />
        <div className="container">{children}</div>
        <Footer />
      </React.Fragment>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
